export const TABLE_TYPES = ['PUBLIC', 'PRIVATE', 'TOURNAMENT'];
export const STATUS_OPTIONS = ["ALL", "WAITING", "IN_GAME", "IN_MATCH"];
export const OCCUPANCY_OPTIONS = ['all', 'empty', 'waiting', 'full'];
export const SORT_OPTIONS = [
    { key: 'SEATS_AVAILABLE', label: 'Seats Available' },
    { key: 'OCCUPANCY', label: 'Occupancy' },
    { key: 'TOTAL_SEATS', label: 'Total Seats' },
    { key: 'STATUS', label: 'Status' },
    { key: 'TABLE_ID', label: 'Table Name' },
];

export const OCCUPANCY_LABELS = {
    all: 'All',
    empty: 'Empty',
    waiting: 'Waiting',
    full: 'Full',
};
export function filterTables(tables, filters) {
    return tables.filter((t) => {
        if (filters.type.toString().toLocaleLowerCase() !== 'all' && t.tableType !== filters.type) return false;
        if (filters.status.toString().toLocaleLowerCase() !== 'all' && t.status !== filters.status) return false;
        if (filters.seats.toString().toLocaleLowerCase() !== 'all' && t.numberOfSeats !== filters.seats) return false;

        switch (filters.occupancy) {
            case 'empty':
                return t.numOccupiedSeats === 0;
            case 'full':
                return t.numOccupiedSeats === t.numberOfSeats;
            case 'waiting':
                return t.numOccupiedSeats > 0 && t.numOccupiedSeats < t.numberOfSeats;
            default:
                return true;
        }
    });
}


export function sortTables(tables, key, direction) {
    const dir = direction === 'asc' ? 1 : -1;

    return [...tables].sort((a, b) => {
        switch (key) {
            case 'TABLE_ID':
                return (
                    a.tableId.localeCompare(b.tableId, undefined, {
                        sensitivity: 'base',
                        numeric: true,
                    }) * dir
                );

            case 'SEATS_AVAILABLE':
                return (
                    ((a.numberOfSeats - a.numOccupiedSeats) -
                        (b.numberOfSeats - b.numOccupiedSeats)) *
                    dir
                );

            case 'OCCUPANCY':
                return (
                    ((a.numOccupiedSeats / a.numberOfSeats) -
                        (b.numOccupiedSeats / b.numberOfSeats)) *
                    dir
                );

            case 'TOTAL_SEATS':
                return (a.numberOfSeats - b.numberOfSeats) * dir;

            case 'STATUS': {
                const PRIORITY = {
                    ALL: 0,
                    WAITING: 1,
                    IN_MATCH: 2,
                    IN_GAME: 3,
                };
                return (PRIORITY[a.status] - PRIORITY[b.status]) * dir;
            }

            default:
                return 0;
        }
    });
}
